function makeBasicIssueReasonValue(path, value) {
  return {path, value};
}

export default makeBasicIssueReasonValue;
